module.exports = __webpack_public_path__ + "assets/teacher.d2acd17c.svg";